import { render, staticRenderFns } from "./Electrician.vue?vue&type=template&id=32f617c9&scoped=true&"
import script from "./Electrician.vue?vue&type=script&lang=js&"
export * from "./Electrician.vue?vue&type=script&lang=js&"
import style0 from "./Electrician.vue?vue&type=style&index=0&id=32f617c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f617c9",
  null
  
)

export default component.exports